import axios, { AxiosInstance } from 'axios';
import { BurnRuleResult } from '@loyalty/shared-common/event-processing-api-client';
import { v4 as uuid } from 'uuid';

export class BurnRewardApiClient {
  private readonly http: AxiosInstance;

  constructor() {
    this.http = axios.create();
  }

  async burnReward(programId: string, ruleId: string): Promise<BurnRuleResult> {
    const { data } = await this.http.post<BurnRuleResult>(
      `/l/${programId}/participant/buy-reward/${ruleId}`,
      {},
      {
        headers: { 'x-request-id': uuid() },
      },
    );

    return data;
  }
}
